// Color palette for the app
const lightColors = {
  primary: '#FF4500', // Primary color - Orange
  primaryLight: '#FF7A45', // Lighter shade of primary
  primaryDark: '#E63E00', // Darker shade of primary
  secondary: '#4A90E2', // Secondary color - Blue
  white: '#FFFFFF',
  black: '#000000',
  grey: {
    light: '#F5F5F5',
    medium: '#9E9E9E',
    dark: '#616161',
  },
  success: '#4CAF50', // Green
  error: '#F44336', // Red
  warning: '#FFC107', // Yellow
  info: '#2196F3', // Light Blue
  transparent: 'transparent',
  background: '#F9F9F9',
  card: '#FFFFFF',
  text: '#212121',
  border: '#E0E0E0',
};

// Dark theme colors
const darkColors = {
  primary: '#FF4500', // Primary color remains the same for brand identity
  primaryLight: '#FF7A45',
  primaryDark: '#E63E00',
  secondary: '#4A90E2',
  white: '#FFFFFF',
  black: '#000000',
  grey: {
    light: '#2C2C2C',
    medium: '#9E9E9E',
    dark: '#BBBBBB',
  },
  success: '#4CAF50',
  error: '#F44336',
  warning: '#FFC107',
  info: '#2196F3',
  transparent: 'transparent',
  background: '#121212',
  card: '#1E1E1E',
  text: '#F5F5F5',
  border: '#333333',
};

// Typography
export const typography = {
  fontFamily: {
    regular: 'System',
    medium: 'System',
    bold: 'System',
  },
  fontSize: {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20,
    xxl: 24,
    xxxl: 32,
  },
  fontWeight: {
    light: '300',
    regular: '400',
    medium: '500',
    bold: '700',
  },
};

// Spacing
export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
  xxxl: 64,
};

// Border radius
export const borderRadius = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
  round: 999,
};

// Shadows for light mode
const lightShadows = {
  light: {
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
  },
  medium: {
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.15,
    shadowRadius: 6,
    elevation: 5,
  },
  dark: {
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.2,
    shadowRadius: 8,
    elevation: 8,
  },
};

// Shadows for dark mode
const darkShadows = {
  light: {
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.3, // Higher opacity for dark mode
    shadowRadius: 3,
    elevation: 4,
  },
  medium: {
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.4,
    shadowRadius: 6,
    elevation: 6,
  },
  dark: {
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.5,
    shadowRadius: 8,
    elevation: 9,
  },
};

// Theme objects
export const lightTheme = {
  colors: lightColors,
  typography,
  spacing,
  borderRadius,
  shadows: lightShadows,
};

export const darkTheme = {
  colors: darkColors,
  typography,
  spacing,
  borderRadius,
  shadows: darkShadows,
};

// Export the colors separately for backward compatibility
export const colors = lightColors; 